import { HariseninFooter } from "@components/harisenin"
import { Header } from "@components/header"
import { School } from "@interfaces/school"
// import { useAnalytics } from "@lib/context/analytics"
import Helmet from "@lib/helpers/Helmet"
import { useScreenSize } from "@lib/hooks/useScreenSize"
import { useEffect } from "react"
import BootcampAlumnusCompany from "../components/bootcamp/BootcampAlumnusCompany"
import BootcampCta from "../components/bootcamp/BootcampCta"
import BootcampFaqContainer from "../components/bootcamp/BootcampFaqContainer"
import BootcampHeroInfo from "../components/bootcamp/BootcampHeroInfo"
import { BootcampListBanner } from "../components/bootcamp/BootcampListBanner"
import { BootcampListColumn } from "../components/bootcamp/BootcampListColumn"
import { BootcampListStatistic } from "../components/bootcamp/BootcampListStatistic"
import { BootcampTestimonial } from "../components/bootcamp/BootcampTestimonial"
import BootcampWhyColumn from "../components/bootcamp/BootcampWhyColumn"
import dynamic from "next/dynamic"
import TestimonyVideo from "../components/bootcamp/TestimonyVideo"

const FloatingWhatsApp = dynamic(() => import("@harisenin/react-floating-whatsapp"), { ssr: false })

export interface ProgramListPage {
  bootcamps: School[]
  metaTitle: string
  metaDescription: string
  videoTestimonies?: any
  bannerInfo?: any
}

const BootcampListPage = ({
  bootcamps,
  metaDescription,
  metaTitle,
  videoTestimonies,
  bannerInfo,
}: ProgramListPage) => {
  const { screenWidth } = useScreenSize()
  // const { analytics } = useAnalytics()

  // useEffect(() => {
  //   analytics.track("Product List Viewed", {
  //     products: [
  //       {
  //         product_id: "",
  //         name: "",
  //         affiliation: "PT. Karya Kaya Bahagia",
  //         coupon: "",
  //         discount: 0,
  //         currency: "IDR",
  //         brand: "HMS",
  //         category: "Bootcamp",
  //         variant: "",
  //         price: 0,
  //         quantity: 1,
  //         position: 0,
  //         item_list_name: "",
  //         item_list_id: "",
  //       },
  //     ],
  //     item_list_name: "",
  //     item_list_id: "",
  //   })
  // }, [])

  const executeScroll = (id: string) => () => {
    const ele = document.getElementById(id)

    if (!ele) {
      return
    }

    ele.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <>
      <Helmet
        title={metaTitle ?? "Harisenin.com: Semua Program"}
        description={metaDescription}
        isIndexed
      />

      <FloatingWhatsApp
        phoneNumber="+6281312117711"
        accountName="Customer Services"
        allowClickAway
        notification
        notificationDelay={30000}
      />

      <Header hasShadow />

      <main className="font-inter">
        <BootcampListBanner screenWidth={screenWidth} executeScroll={executeScroll} />
        <BootcampListStatistic screenWidth={screenWidth} bannerInfo={bannerInfo} />
        <BootcampHeroInfo />
        <BootcampListColumn data={bootcamps} />
        <BootcampWhyColumn screenWidth={screenWidth} />
        <BootcampAlumnusCompany />{" "}
        <TestimonyVideo testimonies={videoTestimonies} screenWidth={screenWidth} />
        <BootcampTestimonial screenWidth={screenWidth} />
        <BootcampFaqContainer />
        <BootcampCta />
      </main>

      <HariseninFooter />
    </>
  )
}

export default BootcampListPage
